import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, Params } from '@angular/router';
import {PoStorageService} from '@po-ui/ng-storage';
import {Observable} from 'rxjs';
import {AuthService} from '../service/auth.service';
import {Token} from '../interface/usuario';


@Injectable({
  providedIn: 'root'
})
export class MaistiGuard  {

  constructor(private poStorageService: PoStorageService, private authService: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url: string = state.url;
    let permissao = '';
    if (route.children && route.children.length) {
      permissao = route.children[0].data.permissao;
    } else {
      permissao = route.data.permissao;
    }

    return this.checkAcess(url, route.queryParams, permissao).then(value => {
      return value;
    });
  }

  // @ts-ignore
  async checkAcess(url: string, params: Params, permissao: string): Promise<boolean | UrlTree> {

    return new Promise((resolve, reject) => {
      this.poStorageService.get('usuario')
        .then(usuario => {
          if (usuario) {
            const tokenJson = localStorage.getItem('token');
            if (tokenJson) {
              const token = JSON.parse(tokenJson) as Token;
              const diffTime = Math.abs(token.last_token_refresh - new Date().getTime() / 1000);
              if (diffTime > token.expires_in - 600) {
                this.authService.refreshToken(token.refresh_token).subscribe({
                  next: (newToken) => {
                  localStorage.setItem('token', JSON.stringify({...newToken, last_token_refresh: new Date().getTime() / 1000}));
                  }, error: () => {
                  localStorage.clear();
                  this.poStorageService.clear();
                  this.poStorageService.set('redirectUrl', url);
                  this.router.navigateByUrl('/login');
                  resolve(false);
                  }
                });
              }
              if (permissao && permissao.length) {
                // @ts-ignore
                // tslint:disable-next-line:max-line-length
                const aPermissao = usuario.APRIVILEGIO.filter(item => permissao.includes(item.CCODIGO));
                if (aPermissao && aPermissao.length) {
                  resolve(true);
                } else {
                  this.router.navigateByUrl('/');
                  resolve(false);
                }
              } else {
                resolve(true);
              }
            } else {
              localStorage.clear();
              this.poStorageService.clear();
              this.poStorageService.set('redirectUrl', url);
              this.router.navigateByUrl('/login');
              resolve(false);
            }

          } else {
            localStorage.clear();
            this.poStorageService.clear();
            this.poStorageService.set('redirectUrl', url);
            this.router.navigateByUrl('/login');
            resolve(false);
          }
        })
        .catch(() => {
          localStorage.clear();
          this.poStorageService.clear();
          this.poStorageService.set('redirectUrl', url);
          this.router.navigateByUrl('/login');
          resolve(false);
        });
    });


  }

}
